import { AxiosRequestConfig } from 'axios';

import axios from '../../../axios';
import ITeamFilters from '../types/ITeamFilters';

const url = '/api/teams';
const urlTeamMembers = '/api/team-members';

//get team we are part of
export const getMyTeams = () => axios.get(`${url}/memberteam`);

export const getCurrentUserTeams = () => axios.get(`${url}/current_user_teams`);

export const getOverlapTeams = (email: string) => axios.post(`${url}/overlap`, email);

//to get teams owns by login user
export const getAllTeamsInWorkspace = () => axios.get(`${url}/team`);

export const getAllTeamMemberRecordsOfTeam = (teamId: string, teamFilters: ITeamFilters) =>
  axios.post(`${urlTeamMembers}/members/${teamId}`, teamFilters);

export const findTeamById = (teamId: string) => axios.get(`${url}/${teamId}`);

export const findMultipleTeamsByIds = (teamIds: string[]) =>
  axios.post(`${url}/get-all-teams-by-ids`, teamIds);

export const getAllWorkspaceTeams = () => axios.get(`${url}/teamsInWorkspace`);

export const getTeamsSuggestions = (team: string, config?: AxiosRequestConfig) =>
  axios.get(`${url}/suggestions/all?query=${team}`, config);

export const getAllWorkspaceTeamsFilters = (teamFilters: ITeamFilters) =>
  axios.post(`${url}/workspace`, teamFilters);
